export enum ColorToken {
  primary,
  secondary,
  greyPrimary,
  greySecondary,
  interactiveHiglightInactive,
  interactiveHiglightHover,
  interactiveHiglightActive,

  brinkbitBlue,
  brinkbitPrimary,
  brinkbitSecondary,
  brinkbitGreyPrimary,
  brinkbitGreySecondary,

  sparkPrimary,
  sparkSecondary,
  sparkGreyPrimary,
  sparkGreySecondary,
  sparkGreyTertiary,
  sparkGradient1,
  sparkGradient2,
  sparkGradient3,
  sparkGradient4,
  sparkGradient5,
  sparkGradient6,
  sparkGradient7,
  sparkGradient8,
  sparkGreyGradient1,
  sparkGreyGradient2,
  sparkGreyGradient3,
  sparkGreyGradient4,
  sparkGreyGradient5,
  sparkGreyGradient6,
  sparkGreyGradient7,
  sparkGreyGradient8,
  sparkMonoOrange,
  sparkMonoOrangeDesaturated,
  sparkMonoRed,
  sparkMonoRedDesaturated,
  sparkMonoYellow,
  sparkMonoYellowDesaturated,

  hitchdPink,
  hitchdOrange,
  hitchedLargeColorFill,
  hitchdSecondary,
  hitchdPinkDesaturated,
  hitchdGreyPrimary,
}

export enum ColorThemeId {
  light,
  dark,
}

export type ColorTheme = Record<ColorToken, string>;
